module.exports = __webpack_public_path__ + "media/application/images/2018/2018-sidebar-guide-45090dc2886858e71a277cfa18a681f5.jpg";